import { forwardRef } from '@angular/core';
import { Type } from 'class-transformer';
import { BaseModel } from '../../shared/models/base.model';
import { PermissionModel } from './permission.model';

export class RoleModel extends BaseModel {
    name: string;
    identificationValue: string;

    @Type(forwardRef(() => PermissionModel) as any)
    lstPermissions: PermissionModel[];
}
